export default [
  {
    title: 'Routing & Switching',
    workbooks: [
      {
        title: 'CCNP TSHOOT Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccnp-tshoot-workbook/',
      },
      {
        title: 'CCNP Switch Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccnp-switch-workbook/',
      },
      {
        title: 'CCNP Route Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccnp-route-workbook/',
      },
      {
        title: 'CCNA Routing & Switching v3.0 ICND2 Workbook',
        link:
          'https://my.ine.com/course/ine-ccna-rsv3-icnd2-workbook/7be0b2b4-2ef0-4d12-ac51-28aaf25a56fa',
      },
      {
        title: 'CCNA Routing & Switching v3.0 ICND1 Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccna-rs-v3-workbook',
      },
      {
        title: 'CCNA Routing & Switching Lab Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccna-rs-workbook',
      },
      {
        title: 'CCIE Routing & Switching v5 Lab Workbook',
        link: 'https://labs.ine.com/workbook/toc/rs-v5-workbook',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #4',
        link: 'https://labs.ine.com/workbook/toc/rs-online-graded-lab-4',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #3',
        link: 'https://labs.ine.com/workbook/toc/rs-online-graded-lab-3',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #2',
        link: 'https://labs.ine.com/workbook/toc/rs-online-graded-lab-2',
      },
      {
        title: 'CCIE Routing & Switching Online Graded Lab #1',
        link: 'https://labs.ine.com/workbook/toc/rs-online-graded-lab',
      },
      {
        title:
          'CCIE Routing & Switching (v4) Volume II - Full-Scale Practice Labs (Online)',
        link: 'https://labs.ine.com/workbook/view/rs-volii-full-scale-labs',
      },
      {
        title:
          'CCIE Routing & Switching (v4) Volume I - Advanced Technology Labs (Online)',
        link: 'https://labs.ine.com/workbook/view/rs-advanced-technology-labs',
      },
    ],
  },
  {
    title: 'Security',
    workbooks: [
      {
        title: 'CCIE Security v5 Bootcamp Workbook',
        link: 'https://labs.ine.com/workbook/toc/INE-SCV5-ONL-BCWB',
      },
      {
        title: 'CCIE Security v4 Technologies Workbook',
        link: 'https://labs.ine.com/workbook/view/security-technology-labs',
      },
      {
        title: 'CCIE Security v4 Practice Labs Workbook',
        link: 'https://labs.ine.com/workbook/view/security-full-scale-labs',
      },
    ],
  },
  {
    title: 'Service Provider',
    workbooks: [
      {
        title: 'CCIE Service Provider Lab Workbook v4 (Online)',
        link: 'https://labs.ine.com/workbook/toc/service-provider-v4/',
      },
      {
        title: 'CCIE Service Provider Lab Workbook v3 (Online)',
        link: 'https://labs.ine.com/workbook/view/service-provider-v3/',
      },
    ],
  },
  {
    title: 'Data Center',
    workbooks: [
      {
        title: 'UCS Advanced Technology Labs',
        link: 'https://labs.ine.com/workbook/view/ucs-technology-labs/',
      },
      {
        title: 'Nexus Advanced Technology Labs',
        link: 'https://labs.ine.com/workbook/view/nexus-technology-labs/',
      },
      {
        title: 'CCIE Data Center v2 Lab Workbook (beta)',
        link: 'https://labs.ine.com/workbook/toc/dcv2-lab-workbook',
      },
    ],
  },
  {
    title: 'Collaboration',
    workbooks: [
      {
        title: 'CCIE Collaboration Workbook',
        link: 'https://labs.ine.com/workbook/toc/ccie-collaboration',
      },
    ],
  },
]
